import { render, staticRenderFns } from "./ProjectsPlane.vue?vue&type=template&id=90948a22&lang=pug&"
import script from "./ProjectsPlane.vue?vue&type=script&lang=js&"
export * from "./ProjectsPlane.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPlane.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports